import React from 'react';
import { connect } from 'react-redux';
import Title from 'ui/Title';
import theme from 'ui/theme';
import { Wrapper } from './styles';
import Grid from './Grid';

class Clientify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { loading } = this.state;

    return (
      <Wrapper theme={theme}>
        <Title>Clientify Logs</Title>
        { loading }
        <Grid />
      </Wrapper>
    );
  }
}

Clientify.propTypes = {
};

Clientify.defaultProps = {
};

export default connect(
  state => ({
    loading: state.clientifies.loading,
    result: state.clientifies.result,
  }),
)(Clientify);
